import { useMutation } from '@tanstack/react-query';
import api from '../api/client';
import toast from 'react-hot-toast';
import { extractErrorMessage } from '../utils/errorHandler';

export const useAtualizarPerfil = () => {
  return useMutation({
    mutationFn: async (data: { nome: string; email: string }) => {
      const response = await api.put('/usuarios/perfil', data);
      return response.data as { id: number; nome: string; email: string };
    },
    onError: (error: any) => {
      toast.error(extractErrorMessage(error, 'Erro ao atualizar perfil'));
    },
  });
};

export const useAlterarSenhaPerfil = () => {
  return useMutation({
    mutationFn: async (data: { senhaAtual: string; novaSenha: string; confirmarNovaSenha: string }) => {
      const response = await api.patch('/usuarios/perfil/senha', data);
      return response.data as { mensagem: string };
    },
    onError: (error: any) => {
      toast.error(extractErrorMessage(error, 'Erro ao alterar senha'));
    },
  });
};
